import { render } from "./FindPassword.vue?vue&type=template&id=3673067b&scoped=true"
import script from "./FindPassword.vue?vue&type=script&lang=js"
export * from "./FindPassword.vue?vue&type=script&lang=js"

import "./FindPassword.vue?vue&type=style&index=0&id=3673067b&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3673067b"]])

export default __exports__